import * as React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { textFieldSx } from './PresentationWizard.styles';

function DetailsStep({ name, setName, description, setDescription, validationErrors, setValidationErrors }) {
  return (
    <>
      <Typography
        variant="body1"
        sx={{ color: '#64748b', marginBottom: '24px', fontSize: '16px' }}
      >
        Enter the presentation name and description.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <TextField
          fullWidth
          label="Presentation Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (validationErrors.name) setValidationErrors((prev) => { const { name: _, ...rest } = prev; return rest; });
          }}
          placeholder="Enter presentation name"
          error={!!validationErrors.name}
          helperText={validationErrors.name}
          sx={textFieldSx(!!validationErrors.name)}
        />
        <TextField
          fullWidth
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Brief description of this presentation"
          multiline
          minRows={2}
          maxRows={6}
          sx={textFieldSx(false)}
        />
      </Box>
    </>
  );
}

export default DetailsStep;
